// src/store/store.js
import { createStore, combineReducers, applyMiddleware, compose  } from 'redux';
import notificationReducer from 'Store/reducers/notificationReducer';
import profileListReducer from './reducers/profileListReducer';
import { thunk } from 'redux-thunk';

const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const rootReducer = combineReducers({
    notification: notificationReducer,
    profileList: profileListReducer,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
